import { defineMessages, plural } from "../i18n/core";

// Backup de bancos de dados na página da máquina (ADR 0023).
export const machineDatabasesMessages = defineMessages({
  "pt-BR": {
    intro: "A ferramenta do próprio banco gera um arquivo por banco, com o banco no ar. O repositório comprime, deduplica e criptografa.",
    add: "Adicionar instância",
    engine: { postgresql: "PostgreSQL", mysql: "MySQL / MariaDB", sqlserver: "SQL Server", oracle: "Oracle", firebird: "Firebird" },
    engineSoon: (name: string) => `${name} (em breve)`,
    foundTitle: "Encontrados nesta máquina",
    foundHint: "O agente achou estes motores de banco. Cadastre para começar a copiar.",
    foundWhere: (where: string) => `em ${where}`,
    register: "Cadastrar",
    none: "Nenhuma instância de banco cadastrada nesta máquina.",
    connSocket: (path: string) => `socket ${path}`,
    connLocal: "conexão local padrão",
    authOs: (user: string) => (user ? `autenticação do sistema (${user})` : "autenticação do sistema"),
    authPassword: (user: string) => `usuário ${user}, senha guardada`,
    allDatabases: "todos os bancos",
    someDatabases: (n: number) => `${n} ${plural(n, "banco", "bancos")}`,
    scheduleOwn: (time: string) => `todo dia às ${time}`,
    scheduleHourly: "de hora em hora",
    scheduleFromPolicy: "agenda da política",
    disabled: "Desligada",
    disabledHint: "Não copia pela agenda; teste e backup na hora continuam valendo.",
    neverTested: "Ainda não testada",
    testOk: (when: string) => `Teste aprovado ${when}`,
    testFailed: (when: string) => `Teste falhou ${when}`,
    role: { primary: "nó primário do cluster", secondary: "nó secundário do cluster" } as Record<string, string>,
    serverInfo: (version: string, tool: string, toolVersion: string) => `servidor ${version} · ${tool} ${toolVersion}`,
    seenDatabases: (names: string) => `Bancos vistos: ${names}`,
    test: "Testar",
    testing: "Testando…",
    testSteps: "Passos do teste",
    stepStatus: { ok: "feito", warn: "aviso", fail: "falhou" },
    backupNow: "Backup agora",
    backingUp: "Copiando…",
    edit: "Editar",
    remove: "Remover",
    testSent: (name: string) => `Teste de ${name} enviado ao agente.`,
    backupSent: (name: string) => `Backup de ${name} enviado ao agente.`,
    actionFailed: "Não foi possível enviar o pedido.",
    backups: "Backups",
    noBackups: "Nenhum backup desta instância ainda.",
    colWhen: "Backup",
    colDatabase: "Banco",
    colSize: "Tamanho",
    colActions: "Ações",
    when: (date: string, time: string) => `${date} às ${time}`,
    triggerManual: "manual",
    triggerSchedule: "agendado",
    globals: "papéis e tablespaces",
    download: "Baixar",
    manifest: "Manifesto",
    manifestHint: "Descreve o backup e traz o comando de restauração.",
    downloadStarted: "Download iniciado. O arquivo chega sem compressão: pode ser grande.",
    removedInstance: (engine: string) => `Instância removida (${engine})`,
    removeTitle: (name: string) => `Remover ${name}?`,
    removeDescription: "Saem o cadastro e a senha guardada. Os backups já feitos continuam disponíveis até a retenção da política apagar.",
    removed: (name: string) => `${name} removida.`,
    removeFailed: "Não foi possível remover.",

    createTitle: "Nova instância de banco",
    editTitle: (name: string) => `Editar ${name}`,
    fieldName: "Nome",
    namePlaceholder: "ERP (PostgreSQL)",
    fieldEngine: "Motor",
    engineFixed: "O motor não muda depois de criado.",
    fieldHost: "Servidor",
    hostHint: "Vazio: o banco desta máquina.",
    fieldPort: "Porta",
    fieldSocket: "Socket Unix",
    socketHint: "Caminho absoluto. Só para banco local no Linux.",
    fieldAuth: "Autenticação",
    authOsOption: "Sistema operacional",
    authPasswordOption: "Usuário e senha",
    authOsHint: "O agente roda a ferramenta como o dono do banco (peer, socket). Nenhuma senha é guardada.",
    authPasswordHint: "A senha fica cifrada no servidor e só é entregue ao agente durante um teste ou backup.",
    fieldOsUser: "Usuário do sistema",
    osUserHint: "Dono do banco no sistema: postgres, mysql.",
    oracleSummary: (sid: string, mode: string) => `instância ${sid} · ${mode}`,
    oracleSameMachine: "O agente precisa estar na máquina do banco: Data Pump e RMAN escrevem no disco do servidor.",
    fieldSid: "Instância (SID)",
    sidHint: "O nome do processo ora_pmon_<SID> ou do serviço OracleService<SID>.",
    sidRequired: "Informe o SID: até 16 caracteres, começando por letra.",
    fieldMode: "Modo",
    modeDataPumpHint: "Export lógico com o banco no ar, em qualquer edição e modo de log. Restaura em outro banco ou schema.",
    modeRmanHint: "Backup físico com archived logs. Só em ARCHIVELOG; o teste confere.",
    fieldStaging: "Área de preparação",
    stagingHint: "Diretório no servidor onde o backup nasce antes de subir. Vazio: o agente usa o DATA_PUMP_DIR ou a FRA.",
    deleteArchivedLogs: "Apagar os archived logs depois de copiá-los",
    deleteArchivedLogsHint: "Libera a FRA. Deixe desligado se outro backup também precisa desses logs.",
    authOsOracleHint: "O agente roda as ferramentas como o dono da instância e conecta com / as sysdba. Nenhuma senha é guardada.",
    authPasswordOracleHint: "Usuário com SYSBACKUP (RMAN) ou DATAPUMP_EXP_FULL_DATABASE (Data Pump). No Windows costuma ser necessário.",
    grantsTitle: "Comandos para criar este usuário no banco",
    grantsHint: "Rode como administrador do banco, trocando <senha> pela senha que vai informar acima. É o mínimo que o agente precisa; a senha nunca aparece aqui.",
    grantsLabel: "script de criação do usuário",
    grantsPostgres: "PostgreSQL 14 ou mais novo. Em versão anterior, em cada banco: GRANT SELECT ON ALL TABLES IN SCHEMA public TO usuário; e ALTER DEFAULT PRIVILEGES IN SCHEMA public GRANT SELECT ON TABLES TO usuário;. Sem superusuário, os papéis saem sem senha (o teste avisa). O pg_hba.conf precisa aceitar este usuário com senha a partir desta máquina.",
    grantsMysql: "Em InnoDB Cluster, rode no nó primário: o usuário replica para os demais. Se o banco fica em outra máquina, troque o endereço pelo desta máquina, como o servidor a enxerga.",
    grantsOracle: "Em CDB (12c ou mais novo), dê ao usuário o prefixo C##: o script vira usuário comum, com CONTAINER=ALL. SYSBACKUP existe a partir do 12c; no 11g use SYSDBA. Conectar com SYSBACKUP ou SYSDBA exige o arquivo de senha (orapwd).",
    grantsSqlserver: "db_backupoperator em cada banco basta para o BACKUP ... WITH COPY_ONLY; VIEW ANY DEFINITION deixa o agente ler os tamanhos. Banco criado depois precisa do mesmo USE/CREATE USER; o teste avisa qual ficou sem.",
    grantsSqlserverIntegrated: "Com autenticação integrada quem entra é a conta do serviço do agente (SYSTEM). Rode este script para dar a ela o direito de backup; a senha não existe.",
    sqlserverSummary: (instance: string) => `instância ${instance || "padrão"}`,
    sqlserverSameMachine: "O agente precisa estar na máquina do banco: o BACKUP DATABASE escreve o .bak no disco do servidor, e o agente sobe o arquivo de lá.",
    fieldInstance: "Instância nomeada",
    instanceHint: "Vazio: a instância padrão (MSSQLSERVER). Nomeada: o nome depois de MSSQL$ no serviço, como SQLEXPRESS; o SQL Browser resolve a porta, ou informe-a ao lado.",
    instanceInvalid: "Nome de instância: até 16 caracteres, começando por letra.",
    stagingHintSqlserver: "Pasta no servidor onde o .bak nasce antes de subir, gravável pela conta do serviço do SQL Server. Vazio: a pasta de backup padrão da instância.",
    authOsSqlserverHint: "Windows: autenticação integrada com a conta do serviço do agente (SYSTEM), sem senha guardada. Em Linux não existe; use usuário e senha.",
    authPasswordSqlserverHint: "Login do SQL Server com db_backupoperator nos bancos a copiar. Obrigatório em Linux.",
    fieldWhatPdbs: "Quais PDBs",
    whatAllPdbs: "Todos os abertos",
    fieldPdbs: "PDBs",
    fieldUser: "Usuário do banco",
    fieldPassword: "Senha",
    passwordKeep: "Deixe vazio para manter a senha guardada.",
    fieldWhat: "O que copiar",
    whatAll: "Todos os bancos",
    whatList: "Só estes",
    fieldDatabases: "Bancos",
    databasesHint: "Um por linha ou separados por vírgula.",
    fieldSchedule: "Agenda",
    schedulePolicy: "A da política",
    scheduleCustom: "Própria",
    fieldTime: "Horário",
    fieldWindow: "Janela (horas)",
    fieldDays: "Dias",
    enabled: "Copiar pela agenda",
    create: "Cadastrar",
    save: "Salvar",
    created: (name: string) => `${name} cadastrada. Rode um teste antes do primeiro backup.`,
    saved: (name: string) => `${name} salva.`,
    saveFailed: "Não foi possível salvar.",
    nameRequired: "Dê um nome à instância.",
    databasesRequired: "Liste pelo menos um banco, ou escolha todos.",
    userRequired: "Informe o usuário do banco.",
    passwordRequired: "Informe a senha.",
  },
  "en-US": {
    intro: "The database's own tool writes one file per database, with the database online. The repository compresses, deduplicates and encrypts.",
    add: "Add instance",
    engine: { postgresql: "PostgreSQL", mysql: "MySQL / MariaDB", sqlserver: "SQL Server", oracle: "Oracle", firebird: "Firebird" },
    engineSoon: (name: string) => `${name} (coming soon)`,
    foundTitle: "Found on this machine",
    foundHint: "The agent found these database engines. Register one to start backing it up.",
    foundWhere: (where: string) => `at ${where}`,
    register: "Register",
    none: "No database instance registered on this machine.",
    connSocket: (path: string) => `socket ${path}`,
    connLocal: "default local connection",
    authOs: (user: string) => (user ? `operating system authentication (${user})` : "operating system authentication"),
    authPassword: (user: string) => `user ${user}, stored password`,
    allDatabases: "all databases",
    someDatabases: (n: number) => `${n} ${plural(n, "database", "databases")}`,
    scheduleOwn: (time: string) => `every day at ${time}`,
    scheduleHourly: "hourly",
    scheduleFromPolicy: "policy schedule",
    disabled: "Off",
    disabledHint: "Not backed up on schedule; testing and on-demand backup still work.",
    neverTested: "Not tested yet",
    testOk: (when: string) => `Test passed ${when}`,
    testFailed: (when: string) => `Test failed ${when}`,
    role: { primary: "cluster primary node", secondary: "cluster secondary node" } as Record<string, string>,
    serverInfo: (version: string, tool: string, toolVersion: string) => `server ${version} · ${tool} ${toolVersion}`,
    seenDatabases: (names: string) => `Databases seen: ${names}`,
    test: "Test",
    testing: "Testing…",
    testSteps: "Test steps",
    stepStatus: { ok: "done", warn: "warning", fail: "failed" },
    backupNow: "Back up now",
    backingUp: "Backing up…",
    edit: "Edit",
    remove: "Remove",
    testSent: (name: string) => `Test of ${name} sent to the agent.`,
    backupSent: (name: string) => `Backup of ${name} sent to the agent.`,
    actionFailed: "The request could not be sent.",
    backups: "Backups",
    noBackups: "No backup of this instance yet.",
    colWhen: "Backup",
    colDatabase: "Database",
    colSize: "Size",
    colActions: "Actions",
    when: (date: string, time: string) => `${date} at ${time}`,
    triggerManual: "manual",
    triggerSchedule: "scheduled",
    globals: "roles and tablespaces",
    download: "Download",
    manifest: "Manifest",
    manifestHint: "Describes the backup and includes the restore command.",
    downloadStarted: "Download started. The file is not compressed: it may be large.",
    removedInstance: (engine: string) => `Removed instance (${engine})`,
    removeTitle: (name: string) => `Remove ${name}?`,
    removeDescription: "The registration and the stored password are removed. Existing backups stay available until the policy retention deletes them.",
    removed: (name: string) => `${name} removed.`,
    removeFailed: "Could not remove.",

    createTitle: "New database instance",
    editTitle: (name: string) => `Edit ${name}`,
    fieldName: "Name",
    namePlaceholder: "ERP (PostgreSQL)",
    fieldEngine: "Engine",
    engineFixed: "The engine cannot change after creation.",
    fieldHost: "Server",
    hostHint: "Empty: the database on this machine.",
    fieldPort: "Port",
    fieldSocket: "Unix socket",
    socketHint: "Absolute path. Only for a local database on Linux.",
    fieldAuth: "Authentication",
    authOsOption: "Operating system",
    authPasswordOption: "User and password",
    authOsHint: "The agent runs the tool as the database owner (peer, socket). No password is stored.",
    authPasswordHint: "The password is stored encrypted on the server and is only handed to the agent during a test or a backup.",
    fieldOsUser: "System user",
    osUserHint: "Owner of the database on the system: postgres, mysql.",
    oracleSummary: (sid: string, mode: string) => `instance ${sid} · ${mode}`,
    oracleSameMachine: "The agent must run on the database machine: Data Pump and RMAN write to the server's disk.",
    fieldSid: "Instance (SID)",
    sidHint: "The name in the ora_pmon_<SID> process or the OracleService<SID> service.",
    sidRequired: "Enter the SID: up to 16 characters, starting with a letter.",
    fieldMode: "Mode",
    modeDataPumpHint: "Logical export with the database online, on any edition and log mode. Restores into another database or schema.",
    modeRmanHint: "Physical backup with archived logs. ARCHIVELOG only; the test checks.",
    fieldStaging: "Staging area",
    stagingHint: "Directory on the server where the backup is written before upload. Empty: the agent uses DATA_PUMP_DIR or the FRA.",
    deleteArchivedLogs: "Delete archived logs after backing them up",
    deleteArchivedLogsHint: "Frees the FRA. Leave off if another backup also needs those logs.",
    authOsOracleHint: "The agent runs the tools as the instance owner and connects with / as sysdba. No password is stored.",
    authPasswordOracleHint: "A user with SYSBACKUP (RMAN) or DATAPUMP_EXP_FULL_DATABASE (Data Pump). Usually required on Windows.",
    grantsTitle: "Commands to create this user in the database",
    grantsHint: "Run as the database administrator, replacing <senha> with the password you will enter above. It is the minimum the agent needs; the password never shows here.",
    grantsLabel: "user creation script",
    grantsPostgres: "PostgreSQL 14 or newer. On older versions, in each database: GRANT SELECT ON ALL TABLES IN SCHEMA public TO user; and ALTER DEFAULT PRIVILEGES IN SCHEMA public GRANT SELECT ON TABLES TO user;. Without superuser, roles are dumped without passwords (the test warns). pg_hba.conf must accept this user with a password from this machine.",
    grantsMysql: "In an InnoDB Cluster, run on the primary node: the user replicates to the others. If the database lives on another machine, replace the address with this machine's, as the server sees it.",
    grantsOracle: "In a CDB (12c or newer), give the user the C## prefix: the script becomes a common user, with CONTAINER=ALL. SYSBACKUP exists from 12c on; on 11g use SYSDBA. Connecting with SYSBACKUP or SYSDBA requires the password file (orapwd).",
    grantsSqlserver: "db_backupoperator in each database is enough for BACKUP ... WITH COPY_ONLY; VIEW ANY DEFINITION lets the agent read sizes. A database created later needs the same USE/CREATE USER; the test says which one is missing.",
    grantsSqlserverIntegrated: "With integrated authentication the agent's service account (SYSTEM) signs in. Run this script to give it backup rights; there is no password.",
    sqlserverSummary: (instance: string) => `instance ${instance || "default"}`,
    sqlserverSameMachine: "The agent must run on the database machine: BACKUP DATABASE writes the .bak to the server's disk, and the agent uploads it from there.",
    fieldInstance: "Named instance",
    instanceHint: "Empty: the default instance (MSSQLSERVER). Named: the name after MSSQL$ in the service, such as SQLEXPRESS; SQL Browser resolves the port, or enter it next to it.",
    instanceInvalid: "Instance name: up to 16 characters, starting with a letter.",
    stagingHintSqlserver: "Folder on the server where the .bak is written before upload, writable by the SQL Server service account. Empty: the instance's default backup folder.",
    authOsSqlserverHint: "Windows: integrated authentication with the agent's service account (SYSTEM), no stored password. Not available on Linux; use user and password.",
    authPasswordSqlserverHint: "A SQL Server login with db_backupoperator in the databases to copy. Required on Linux.",
    fieldWhatPdbs: "Which PDBs",
    whatAllPdbs: "All open ones",
    fieldPdbs: "PDBs",
    fieldUser: "Database user",
    fieldPassword: "Password",
    passwordKeep: "Leave empty to keep the stored password.",
    fieldWhat: "What to back up",
    whatAll: "All databases",
    whatList: "Only these",
    fieldDatabases: "Databases",
    databasesHint: "One per line or separated by commas.",
    fieldSchedule: "Schedule",
    schedulePolicy: "The policy's",
    scheduleCustom: "Its own",
    fieldTime: "Time",
    fieldWindow: "Window (hours)",
    fieldDays: "Days",
    enabled: "Back up on schedule",
    create: "Register",
    save: "Save",
    created: (name: string) => `${name} registered. Run a test before the first backup.`,
    saved: (name: string) => `${name} saved.`,
    saveFailed: "Could not save.",
    nameRequired: "Give the instance a name.",
    databasesRequired: "List at least one database, or choose all.",
    userRequired: "Enter the database user.",
    passwordRequired: "Enter the password.",
  },
  es: {
    intro: "La herramienta del propio motor genera un archivo por base de datos, con la base en línea. El repositorio comprime, deduplica y cifra.",
    add: "Añadir instancia",
    engine: { postgresql: "PostgreSQL", mysql: "MySQL / MariaDB", sqlserver: "SQL Server", oracle: "Oracle", firebird: "Firebird" },
    engineSoon: (name: string) => `${name} (próximamente)`,
    foundTitle: "Encontrados en esta máquina",
    foundHint: "El agente encontró estos motores de base de datos. Registre uno para empezar a copiarlo.",
    foundWhere: (where: string) => `en ${where}`,
    register: "Registrar",
    none: "Ninguna instancia de base de datos registrada en esta máquina.",
    connSocket: (path: string) => `socket ${path}`,
    connLocal: "conexión local predeterminada",
    authOs: (user: string) => (user ? `autenticación del sistema (${user})` : "autenticación del sistema"),
    authPassword: (user: string) => `usuario ${user}, contraseña guardada`,
    allDatabases: "todas las bases",
    someDatabases: (n: number) => `${n} ${plural(n, "base", "bases")}`,
    scheduleOwn: (time: string) => `todos los días a las ${time}`,
    scheduleHourly: "cada hora",
    scheduleFromPolicy: "horario de la política",
    disabled: "Apagada",
    disabledHint: "No se copia por horario; la prueba y la copia inmediata siguen funcionando.",
    neverTested: "Aún sin probar",
    testOk: (when: string) => `Prueba aprobada ${when}`,
    testFailed: (when: string) => `La prueba falló ${when}`,
    role: { primary: "nodo primario del clúster", secondary: "nodo secundario del clúster" } as Record<string, string>,
    serverInfo: (version: string, tool: string, toolVersion: string) => `servidor ${version} · ${tool} ${toolVersion}`,
    seenDatabases: (names: string) => `Bases vistas: ${names}`,
    test: "Probar",
    testing: "Probando…",
    testSteps: "Pasos de la prueba",
    stepStatus: { ok: "hecho", warn: "aviso", fail: "falló" },
    backupNow: "Copiar ahora",
    backingUp: "Copiando…",
    edit: "Editar",
    remove: "Quitar",
    testSent: (name: string) => `Prueba de ${name} enviada al agente.`,
    backupSent: (name: string) => `Copia de ${name} enviada al agente.`,
    actionFailed: "No se pudo enviar la solicitud.",
    backups: "Copias",
    noBackups: "Todavía no hay copias de esta instancia.",
    colWhen: "Copia",
    colDatabase: "Base de datos",
    colSize: "Tamaño",
    colActions: "Acciones",
    when: (date: string, time: string) => `${date} a las ${time}`,
    triggerManual: "manual",
    triggerSchedule: "programada",
    globals: "roles y tablespaces",
    download: "Descargar",
    manifest: "Manifiesto",
    manifestHint: "Describe la copia e incluye el comando de restauración.",
    downloadStarted: "Descarga iniciada. El archivo llega sin comprimir: puede ser grande.",
    removedInstance: (engine: string) => `Instancia eliminada (${engine})`,
    removeTitle: (name: string) => `¿Quitar ${name}?`,
    removeDescription: "Se quitan el registro y la contraseña guardada. Las copias ya hechas siguen disponibles hasta que la retención de la política las borre.",
    removed: (name: string) => `${name} eliminada.`,
    removeFailed: "No se pudo quitar.",

    createTitle: "Nueva instancia de base de datos",
    editTitle: (name: string) => `Editar ${name}`,
    fieldName: "Nombre",
    namePlaceholder: "ERP (PostgreSQL)",
    fieldEngine: "Motor",
    engineFixed: "El motor no cambia después de creado.",
    fieldHost: "Servidor",
    hostHint: "Vacío: la base de esta máquina.",
    fieldPort: "Puerto",
    fieldSocket: "Socket Unix",
    socketHint: "Ruta absoluta. Solo para una base local en Linux.",
    fieldAuth: "Autenticación",
    authOsOption: "Sistema operativo",
    authPasswordOption: "Usuario y contraseña",
    authOsHint: "El agente ejecuta la herramienta como el dueño de la base (peer, socket). No se guarda ninguna contraseña.",
    authPasswordHint: "La contraseña queda cifrada en el servidor y solo se entrega al agente durante una prueba o una copia.",
    fieldOsUser: "Usuario del sistema",
    osUserHint: "Dueño de la base en el sistema: postgres, mysql.",
    oracleSummary: (sid: string, mode: string) => `instancia ${sid} · ${mode}`,
    oracleSameMachine: "El agente debe estar en la máquina de la base: Data Pump y RMAN escriben en el disco del servidor.",
    fieldSid: "Instancia (SID)",
    sidHint: "El nombre del proceso ora_pmon_<SID> o del servicio OracleService<SID>.",
    sidRequired: "Indique el SID: hasta 16 caracteres, empezando por letra.",
    fieldMode: "Modo",
    modeDataPumpHint: "Export lógico con la base en línea, en cualquier edición y modo de log. Restaura en otra base o esquema.",
    modeRmanHint: "Copia física con archived logs. Solo en ARCHIVELOG; la prueba lo comprueba.",
    fieldStaging: "Área de preparación",
    stagingHint: "Directorio en el servidor donde nace la copia antes de subir. Vacío: el agente usa DATA_PUMP_DIR o la FRA.",
    deleteArchivedLogs: "Borrar los archived logs después de copiarlos",
    deleteArchivedLogsHint: "Libera la FRA. Déjelo apagado si otra copia también necesita esos logs.",
    authOsOracleHint: "El agente ejecuta las herramientas como el dueño de la instancia y conecta con / as sysdba. No se guarda contraseña.",
    authPasswordOracleHint: "Usuario con SYSBACKUP (RMAN) o DATAPUMP_EXP_FULL_DATABASE (Data Pump). En Windows suele ser necesario.",
    grantsTitle: "Comandos para crear este usuario en la base de datos",
    grantsHint: "Ejecútalos como administrador de la base, cambiando <senha> por la contraseña que vas a informar arriba. Es lo mínimo que necesita el agente; la contraseña nunca aparece aquí.",
    grantsLabel: "script de creación del usuario",
    grantsPostgres: "PostgreSQL 14 o más nuevo. En versiones anteriores, en cada base: GRANT SELECT ON ALL TABLES IN SCHEMA public TO usuario; y ALTER DEFAULT PRIVILEGES IN SCHEMA public GRANT SELECT ON TABLES TO usuario;. Sin superusuario, los roles salen sin contraseña (la prueba avisa). El pg_hba.conf debe aceptar este usuario con contraseña desde este equipo.",
    grantsMysql: "En un InnoDB Cluster, ejecútalos en el nodo primario: el usuario se replica a los demás. Si la base está en otro equipo, cambia la dirección por la de este equipo, como la ve el servidor.",
    grantsOracle: "En una CDB (12c o más nuevo), dale al usuario el prefijo C##: el script pasa a ser un usuario común, con CONTAINER=ALL. SYSBACKUP existe desde 12c; en 11g usa SYSDBA. Conectar con SYSBACKUP o SYSDBA exige el archivo de contraseñas (orapwd).",
    grantsSqlserver: "db_backupoperator en cada base basta para BACKUP ... WITH COPY_ONLY; VIEW ANY DEFINITION deja al agente leer los tamaños. Una base creada después necesita el mismo USE/CREATE USER; la prueba dice cuál falta.",
    grantsSqlserverIntegrated: "Con autenticación integrada entra la cuenta del servicio del agente (SYSTEM). Ejecuta este script para darle el derecho de copia; no hay contraseña.",
    sqlserverSummary: (instance: string) => `instancia ${instance || "predeterminada"}`,
    sqlserverSameMachine: "El agente debe estar en la máquina de la base: BACKUP DATABASE escribe el .bak en el disco del servidor, y el agente lo sube desde allí.",
    fieldInstance: "Instancia con nombre",
    instanceHint: "Vacío: la instancia predeterminada (MSSQLSERVER). Con nombre: lo que sigue a MSSQL$ en el servicio, como SQLEXPRESS; SQL Browser resuelve el puerto, o indícalo al lado.",
    instanceInvalid: "Nombre de instancia: hasta 16 caracteres, empezando por letra.",
    stagingHintSqlserver: "Carpeta en el servidor donde nace el .bak antes de subir, con escritura para la cuenta del servicio de SQL Server. Vacío: la carpeta de copias predeterminada de la instancia.",
    authOsSqlserverHint: "Windows: autenticación integrada con la cuenta del servicio del agente (SYSTEM), sin contraseña guardada. En Linux no existe; usa usuario y contraseña.",
    authPasswordSqlserverHint: "Login de SQL Server con db_backupoperator en las bases a copiar. Obligatorio en Linux.",
    fieldWhatPdbs: "Qué PDB",
    whatAllPdbs: "Todos los abiertos",
    fieldPdbs: "PDB",
    fieldUser: "Usuario de la base",
    fieldPassword: "Contraseña",
    passwordKeep: "Deje vacío para mantener la contraseña guardada.",
    fieldWhat: "Qué copiar",
    whatAll: "Todas las bases",
    whatList: "Solo estas",
    fieldDatabases: "Bases de datos",
    databasesHint: "Una por línea o separadas por comas.",
    fieldSchedule: "Horario",
    schedulePolicy: "El de la política",
    scheduleCustom: "Propio",
    fieldTime: "Hora",
    fieldWindow: "Ventana (horas)",
    fieldDays: "Días",
    enabled: "Copiar por horario",
    create: "Registrar",
    save: "Guardar",
    created: (name: string) => `${name} registrada. Haga una prueba antes de la primera copia.`,
    saved: (name: string) => `${name} guardada.`,
    saveFailed: "No se pudo guardar.",
    nameRequired: "Dé un nombre a la instancia.",
    databasesRequired: "Indique al menos una base, o elija todas.",
    userRequired: "Indique el usuario de la base.",
    passwordRequired: "Indique la contraseña.",
  },
});
